import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import L from 'leaflet';
import { useMap, MapContainer, Marker, Popup, TileLayer, Polyline, useMapEvent } from 'react-leaflet';
import { showNotice } from '../../../../src/notice/Actions';
import { showConfirm } from '../../../../src/confirm/Actions';
import { selectTruck } from '../../../../src/truckSelect/Actions';
import MapTiles from '../../../../src/mapTiles/MapTiles.js';
import TruckSelect from '../../../../src/truckSelect/TruckSelect.js';
import { fetch, paddedNumber, stateValueParser, toETRSTM35FIN } from '../utils.js';
import 'leaflet/dist/leaflet.css';

export const RoadwaySelect = props => (
  <div>
    <label>Ajorata</label>
    {props.last != null ? <div>{'Edellinen: ' + props.last}<br /></div> : null}
    <label className='radio'>
      0
      <input type='radio' name='roadway' value='0'
        onClick={props.onChange.bind(this, 'roadway', 'integer', null)}
        defaultChecked={props.roadway === 0} />
    </label>
    <label className='radio'>
      1
      <input type='radio' name='roadway' value='1'
        onClick={props.onChange.bind(this, 'roadway', 'integer', null)}
        defaultChecked={props.roadway === 1} />
    </label>
    <label className='radio'>
      2
      <input type='radio' name='roadway' value='2'
        onClick={props.onChange.bind(this, 'roadway', 'integer', null)}
        defaultChecked={props.roadway === 2} />
    </label>
  </div>
);

export const DirectionSelect = props => (
  <div>
    <label>Suunta (Automaattinen)</label>
    {props.last != null ? <div>{'Edellinen: ' + props.last}<br /></div> : null}
    <label className='radio'>
      1
      <input id='direction1' type='radio' name='direction' value='1'
        checked={props.direction === 1} readOnly />
    </label>
    <label className='radio'>
      2
      <input id='direction2' type='radio' name='direction' value='2'
        checked={props.direction === 2} readOnly />
    </label>
  </div>
);

export const AccuracyFixer = props => {
  if (!props.show) return null;
  return (
    <div onClick={props.toggle} className='modal'>
      <div onClick={e => e.stopPropagation()} id='accuracy-modal'>
        <h4>Korjataan sijaintia epätarkkuuden takia...</h4>
        <h5>Tämän hetkinen tarkkuus: {props.accuracy} m</h5>
        <div className='loader' />
        <br />
        <button onClick={props.submit}>
          Hyväksy silti
        </button>
        <button onClick={props.toggle}>
          Syötä manuaalisesti
        </button>
      </div>
    </div>
  );
}

class ChangeEdgeFillingView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      height: 0,
      variety: '0-16',
      varietyWeight: 0,
      pit: null,
      truckMass: null,
      notice: null,
      confirmedRoad: false
    };

    this.changeState = this.changeState.bind(this);
    this.doChangeEdgeFilling = this.doChangeEdgeFilling.bind(this);
  }

  componentDidUpdate(lastProps, lastState) {
    if (this.props.edgeFilling == null) return;

    if (this.props.selectedTruck != null && lastProps.selectedTruck !== this.props.selectedTruck) {
      this.setState({
        truckRegisterNumber: this.props.selectedTruck.get('register_number'),
      });
    }

    if (this.props.edgeFilling === lastProps.edgeFilling) return;

    this.props.selectTruck(this.props.edgeFilling.get('truck'));

    this.setState({
      height: this.props.edgeFilling.get('height'),
      variety: this.props.edgeFilling.get('variety'),
      varietyWeight: this.props.edgeFilling.get('variety_weight'),
      pit: this.props.edgeFilling.get('pit'),
      truckMass: this.props.edgeFilling.get('truck_mass'),
      notice: this.props.edgeFilling.get('notice')
    });
  }

  changeState(propertyName, type, defaultValue, event) {
    const value = stateValueParser(event, type, defaultValue);

    if (value == null) {
      return;
    }

    this.setState({ [propertyName]: value });
  }

  async doChangeEdgeFilling() {
    const height = parseFloat(this.state.height);
    if (height === 0) {
      this.props.showNotice('Korkeus ei voi olla 0', 'Warning')
      return;
    }

    if (this.state.variety == null) {
      this.props.showNotice('Lajiketta ei ole valittu', 'Warning');
      return;
    }

    const varietyWeight = parseFloat(this.state.varietyWeight);
    if (varietyWeight === 0) {
      this.props.showNotice('Lajike ominaispaino ei voi olla 0', 'Warning')
      return;
    }

    let edgeFilling = this.props.edgeFilling;
    edgeFilling = edgeFilling.set('height', height);
    edgeFilling = edgeFilling.set('variety', this.state.variety);
    edgeFilling = edgeFilling.set('variety_weight', varietyWeight);
    edgeFilling = edgeFilling.set('pit', this.state.pit);
    edgeFilling = edgeFilling.set('truckId', this.props.selectedTruck.get('id'));
    edgeFilling = edgeFilling.set('truck', null);
    edgeFilling = edgeFilling.set('truck_mass', parseFloat(this.state.truckMass) || null);
    edgeFilling = edgeFilling.set('notice', this.state.notice);

    if (edgeFilling.get('not_saved')) {
      this.props.changeLocalEdgeFilling(edgeFilling);
    }
    else {
      this.props.changeEdgeFilling(edgeFilling);
    }
  }

  render() {
    if (this.props.edgeFilling == null) return null;

    return (
      <div onClick={this.props.clear} className='modal'>
        <div onClick={e => e.stopPropagation()} id='load-data-modal'>
          <h3 className='center'>Reunantäytön muokkaus</h3>
          <div className='row'>
            <div className="column">
              <label htmlFor='height'>Korkeus</label>
              <input id='height' type='tel'
                onChange={this.changeState.bind(this, 'height', 'float', 0.0)} value={this.state.height} required />
            </div>
            <div className="column">
              <label htmlFor='variety'>Lajike</label>
              <select id='variety'
                onChange={this.changeState.bind(this, 'variety', 'string', '')}
                value={this.state.variety}>
                <option value=''>Valitse lajike</option>
                <option value='0-16'>0-16</option>
                <option value='0-32'>0-32</option>
                <option value='0-45'>0-45</option>
                <option value='0-55'>0-55</option>
                <option value='0-63'>0-63</option>
              </select>
            </div>
            <div className="column">
              <label htmlFor='varietyWeight'>Lajike ominaispaino</label>
              <input id='varietyWeight' type='tel'
                onChange={this.changeState.bind(this, 'varietyWeight', 'float', 0.0)}
                value={this.state.varietyWeight} required />
            </div>
            <div className="column">
              <label htmlFor='pit'>Monttu</label>
              <select id='pit' className='float-left'
                onChange={this.changeState.bind(this, 'pit', 'string', '')}
                value={this.state.pit}>
                <option value=''>Valitse monttu</option>
                {
                  this.props.pits.map((pit, index) => (
                    <option key={index} value={pit}>
                      {pit}
                    </option>
                  ))
                }
              </select>
              <button className='button-outline' onClick={this.props.goAddingPit}>
                Uusi monttu
              </button>
            </div>
          </div>
          <div className='row'>
            <div className='column'>
              <label htmlFor='truck'>Rekka</label>
              <TruckSelect required />
            </div>
            <div className='column'>
              <label htmlFor='mass'>Kuorma (Tonnit) </label>
              <input id='mass' type='tel'
                value={this.state.truckMass}
                onChange={this.changeState.bind(this, 'truckMass', 'float', 0.0)} required />
            </div>
            <div className='column'>
              <label htmlFor='notice'>Huomiot</label>
              <input id='notice' type='text' value={this.state.notice || ''}
                onChange={this.changeState.bind(this, 'notice', 'string', '')} />
            </div>
          </div>
          <div className='row'>
            <div className='column'>
              <button onClick={this.doChangeMacadam}>
                Muokkaa
              </button>
            </div>
            <div className='column'>
              <button className='button-outline' onClick={this.props.clear}>
                Peruuta
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  selectedTruck: state.truckSelect.get('selectedTruck'),
  trucks: state.truckSelect.get('trucks'),
}), { selectTruck, showNotice, showConfirm })(ChangeEdgeFillingView);


export const MapView = (properties) => {
  const props = properties;

  let map;
  let trucks = [];
  let position = [64.1, 26.5];
  let zoom = 6;
  let truckUpdateInterval = null;

  const [showedWarning, setShowedWarning] = useState(false);
  const [directions, setDirections] = useState([1, 2]);
  const [trucksState, setTrucksState] = useState([]);
  const [lines, setLines] = useState([]);
  const [height, setHeight] = useState(window.innerHeight * 0.6);
  const [mapTilesUrl, setMapTilesUrl] = useState('');
  const [mapTilesAttribution, setMapTilesAttribution] = useState('');
  const [maxZoom, setMaxZoom] = useState(16);
  const [selectedLine, setSelectedLine] = useState();

  useEffect(() => {
    if (props.mapPosition) {
      position = props.mapPosition;
      zoom = props.mapZoom;
    }

    update(props);
    getTrucks();
    truckUpdateInterval = setInterval(getTrucks, 5000);
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
      clearInterval(truckUpdateInterval);
    };
  }, []);

  const update = async (props) => {
    if (props.mapPaths.length === 0) {
      setLines([]);
      return;
    }

    let lines = [];

    for (let i = 0; i < props.edgeFillings.size; i++) {
      const edgeFilling = props.edgeFillings.get(i);

      for (let p = 0; p < edgeFilling.get('paths').size; p++) {
        const path = edgeFilling.get('paths').get(p);

        if (!(directions.includes(path.get('direction'))) || !path.get('start_latitude')) continue;

        const date = new Date(path.get('date'));
        const time = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
          + ' ' + paddedNumber(date.getHours()) + ':' + paddedNumber(date.getMinutes()) + ':' + paddedNumber(date.getSeconds());

        let color;

        if (selectedLine === path.get('id')) {
          color = '#00FFFF';
        }
        else if (path.get('direction') === 1) {
          color = '#0000FF';
        }
        else {
          color = '#00FF00';
        }

        const text = (
          <span>
            {time}
            <br />
            Aloitus: {path.get('road')} / Osa: {path.get('start_part')} / Paalu: {path.get('start_distance')}
            <br />
            Lopetus: {path.get('road')} / Osa: {path.get('end_part') || '- '} / Paalu: {path.get('end_distance') || '-'}
            <br />
            Ajorata: {path.get('roadway')}
            <br />
            Suunta: {path.get('direction')}
            <br />
            Rekisterinumero: {edgeFilling.get('truck').get('register_number')}
            <br />
            {edgeFilling.get('paths').size > 1 ?
              <div>
                Arvio käytetystä massasta: {Math.round(edgeFilling.get('truck_mass') / edgeFilling.get('paths').size * 100) / 100}
              </div>
              : null
            }
            Kuorman koko: {Math.round(edgeFilling.get('truck_mass') * 100) / 100}
            <br />
          </span>
        );

        const mapPath = props.mapPaths[path.get('id')];

        if (mapPath.length === 1) {
          mapPath.push(mapPath[0]);
        }

        lines.push(
          <Polyline key={path.get('id')}
            positions={mapPath}
            weight={10}
            opacity={0.6}
            color={color}
            onClick={selectLine.bind(null, path.get('id'))}
          >
            <Popup autoPan={false}>
              {text}
            </Popup>
          </Polyline>
        );
      }
    }

    setLines(lines);
  }

  const updateDimensions = () => {
    const height = window.innerHeight * 0.6;
    setHeight(height);
  }

  const getTrucks = () => {
    let trucks = [];

    fetch('/vehicles/' + props.organizationId).then(data => {
      if (!data.vehicles) return;

      data.vehicles.forEach(truck => {
        if (truck['latitude'] != null) {
          const date = new Date(truck['time']);
          const time = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
            + ' ' + paddedNumber(date.getHours()) + ':' + paddedNumber(date.getMinutes()) + ':' + paddedNumber(date.getSeconds());

          trucks.push(
            <Marker key={truck['vehicleId']}
              position={[truck['latitude'], truck['longitude']]}
              icon={new L.Icon({
                iconUrl: 'truck.gif',
                iconSize: [45, 36],
                iconAnchor: [23, 36],
                popupAnchor: [null, -36]
              })}>
              <Popup autoPan={false}>
                <span>
                  {truck['vehicleId']}
                </span>
                <br />
                <span>
                  Viimeisin aika: {time}
                </span>
              </Popup>
            </Marker>
          );
        }
      });

      setTrucksState(trucks);
    }).catch(error => {
      console.log(error);
    });
  }

  const changeDirection = (value, event) => {
    let dirs = directions.slice();

    if (event.target.checked) {
      dirs.push(value);
    }
    else {
      const index = dirs.findIndex(direction => direction === value);
      dirs.splice(index, 1);
    }

    setDirections(dirs);
  }

  const selectLine = (index) => {
    setSelectedLine(index);
  }

  function MapControl() {
    map = useMap();

    useMapEvent('click', (event) => {
      selectLine.bind(null, null);
    });

    const mapCenter = map.getCenter();
    const converted = toETRSTM35FIN(mapCenter.lat, mapCenter.lng);
    const mapTiles = MapTiles(converted.x, converted.y);

    if (mapTilesUrl !== mapTiles.url) {
      setMapTilesUrl(mapTiles.url);
      setMapTilesAttribution(mapTiles.attribution);
      setMaxZoom(mapTiles.maxZoom);
    }
  }

  useEffect(() => {
    update(props);
  }, [directions, selectedLine, props.mapPaths])

  if (props.mapPosition && props.mapZoom) {
    position = props.mapPosition;
    zoom = props.mapZoom;  
  }

  return (
    <div>
      <div className='center'>
        {'Suunnat: '}
        <label>
          1
          <input id='direction1' type='checkbox' name='direction' value='1'
            onChange={changeDirection.bind(this, 1)}
            defaultChecked={directions.includes(1)} />
        </label>
        <label>
          2
          <input id='direction2' type='checkbox' name='direction' value='2'
            onChange={changeDirection.bind(this, 2)}
            defaultChecked={directions.includes(2)} />
        </label>
      </div>
      <div style={{ height: height }}>
        <MapContainer id="map-area" center={position} zoom={zoom} maxZoom={maxZoom}>
          <MapControl />
          <TileLayer url={mapTilesUrl}
            attribution={mapTilesAttribution}
            maxZoom={maxZoom} />
          {props.site != null && props.site.get('coating_plant_laditude') != null ? (
            <Marker position={[props.site.get('coating_plant_laditude'), props.site.get('coating_plant_longitude')]}
              icon={new L.Icon({
                iconUrl: 'coating_plant.gif',
                iconSize: [33, 50],
                iconAnchor: [17, 50],
                popupAnchor: [null, -50]
              })}>
              <Popup>
                <span>{props.site.get('coating_plant_laditude')}, {props.site.get('coating_plant_longitude')}</span>
              </Popup>
            </Marker>
          ) : null}
          {props.yourLatitude != null ? (
            <Marker position={[props.yourLatitude, props.yourLongitude]}
              icon={new L.Icon({
                iconUrl: 'your_location.gif',
                iconSize: [18, 43],
                iconAnchor: [9, 43],
                popupAnchor: [null, -43]
              })}>
              <Popup>
                <span>{props.yourLatitude}, {props.yourLongitude}</span>
              </Popup>
            </Marker>
          ) : null}
          {trucks}
          {lines}
        </MapContainer>
      </div>
      {showedWarning ? 'Yhtä tai useampaa kuormaa ei voida näyttää sijainti tiedon virheellisyyden vuoksi.' : ''}
      {props.edgeFillings.size !== 0 && props.mapPaths.length === 0 ?
        <div className='main loader' /> : null
      }
    </div>
  );
};